import { resolveJsResultChangedDataFieldMap } from '@/common/utils/resolveClientDataActualFields'
import { createSafeClientData } from '@/services/core/core.service'
import type { ExchangeData } from './types'

/** UniData из execute-procedure → ExchangeData для chainCalled и merge. */
export function normalizeProcedureExchangeData(response: unknown): ExchangeData | null {
  if (response == null) return null

  const direct = createSafeClientData(response)
  const directFields = direct?.fields?.fields ?? {}
  if (Object.keys(directFields).length > 0) {
    return direct
  }

  const extracted = resolveJsResultChangedDataFieldMap(
    (response as { jsResult?: { changed_data?: unknown } })?.jsResult?.changed_data ?? response,
  )
  if (Object.keys(extracted).length === 0) {
    return direct
  }

  return createSafeClientData({
    fields: {
      fields: extracted,
      fieldAttributes: {},
      errors: {},
      attributes: {},
    },
  })
}
